module.exports = __webpack_public_path__ + "img/visa.64369366.svg";